export default __webpack_public_path__ + "assets/images/3e36f6fabe16a746bfac52673bb309fb.svg";